export const notificationTypes = {
  TIMELINE_EXPORT: 'TIMELINE_EXPORT',
  USER_ATTENDANCE_EXPORT: 'USER_ATTENDANCE_EXPORT',
};

export const notificationStatuses = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};
export const notificationStatusesText = {
  [notificationStatuses.PENDING]: 'Pending',
  [notificationStatuses.COMPLETED]: 'Completed',
  [notificationStatuses.FAILED]: 'Failed',
};

export const notificationHeading = {
  [notificationTypes.TIMELINE_EXPORT]: 'Timeline Export',
  [notificationTypes.USER_ATTENDANCE_EXPORT]: 'User Attendance Export',
};
